<template>
  <div>
    <template-modal
      :template="templateDetails"
      :callback="templateModified"
      :visible.sync="showTemplateModal"
      v-if="showTemplateModal"
    ></template-modal>
    <el-row class="right-align" :gutter="20">
      <el-col>
        <el-button round type="primary" @click="add()">{{
          $t('add')
        }}</el-button>
        <el-button
          :disabled="!selectedRow"
          round
          type="primary"
          @click="edit"
          >{{ $t('edit') }}</el-button
        >
        <el-button
          :disabled="!selectedRow"
          round
          type="danger"
          @click="remove"
          >{{ $t('remove') }}</el-button
        >
      </el-col>
    </el-row>
    <el-card>
      <el-row>
        <el-table
          :data="tableData"
          v-loading="loading"
          style="width: 100%"
          :row-class-name="tableRowClassName"
          highlight-current-row
          @current-change="handleSelectionChange"
        >
          <el-table-column prop="template_id" label="#">
            <template slot-scope="scope">
              <span
                :data-label="scope.column.label"
                class="responsive-column"
                >{{ scope.row.template_id }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            :label="$t('name')"
          >
            <template slot-scope="scope">
              <span
                :data-label="scope.column.label"
                class="responsive-column"
                >{{ scope.row.name }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="descr"
            :label="$t('title_description')"
          >
            <template slot-scope="scope">
              <span
                :data-label="scope.column.label"
                class="responsive-column"
                >{{ scope.row.descr }}</span
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="aligner right"
          :current-page="pagination.currentPage"
          :page-size="pagination.pageSize"
          layout="total, prev, pager, next"
          :total="pagination.total"
          @current-change="changePage"
        ></el-pagination>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import apiRes from '../../core/apiRes'
import TemplateModal from './TemplateModal'

export default {
  name: 'idcheckTemplates',
  components: {
    'template-modal': TemplateModal
  },
  data: () => ({
    filter: {
      submit: 'Поиск',

      order_field: '',
      order_type: ''
    },

    pagination: {
      total: 0,
      pageSize: 25,
      currentPage: 0
    },
    selectedRow: null,
    templateDetails: {},
    showTemplateModal: false,

    pageLinks: {},
    sortLinks: {},
    tableData: [],
    loading: true
  }),
  created() {
    this.loadTemplates()
  },
  methods: {
    handleSelectionChange(val) {
      this.selectedRow = val
    },
    tableRowClassName(row, index) {
      return row.disabled === 1 ? 'disabled-row' : ''
    },
    processResponse(vars) {
      if (vars) {
        // vars.res.records.forEach(r => {
        //   if (r.date_last) {
        //     r.date_last = new Date(parseInt(r.date_last) * 1000).toLocaleString(this.$locale)
        //   }
        //   if (r.date_orig) {
        //     r.date_orig = new Date(parseInt(r.date_orig) * 1000).toLocaleString(this.$locale)
        //   }
        //   r.show = false
        // })

        this.tableData = Object.keys(vars.res).map(index => vars.res[index])
        this.pagination = {
          total: this.tableData.length,
          currentPage: 1,
          pageSize: this.tableData.length
        }
      } else {
        this.tableData = []
        this.pagination = {}
      }
    },
    parseTemplates(promise) {
      this.loading = true
      this.tableData = []
      promise.then((data) => {
        this.processResponse(data.page_vars)
        this.loading = false
      }).catch(() => {
        this.$notify.error({
          title: this.$t('error'),
          message: ''
        })
        this.loading = false
      })
    },
    loadTemplates() {
      this.loading = true
      this.parseTemplates(apiRes.post(apiRes.idcheckTemplates, {}, true))
    },
    changePage(newPage) {
      if (this.pageLinks[newPage]) {
        this.parseTemplates(apiRes.post(this.pageLinks[newPage]))
      }
    },
    changeSort(sort) {
      this.filter.order_field = sort.prop
      this.filter.order_type = sort.order === 'ascending' ? 'asc' : 'desc'
      this.loadTemplates()

      // if (this.sortLinks[this.filter.order_field]) {
      //   this.parseTemplates(apiRes.get(this.sortLinks[name]))
      // }
    },
    add() {
      this.showTemplateModal = true
      this.templateDetails = {}
    },
    edit() {
      this.showTemplateModal = true
      this.templateDetails = {}
      Object.assign(this.templateDetails, this.selectedRow)
    },
    templateModified(template) {
      this.loadTemplates()
    },
    remove() {
      this.loading = true
      apiRes.post(apiRes.idcheckTemplates, { action: 'delete', id: this.selectedRow.template_id }).finally(() => {
        this.loading = false
        this.loadTemplates()
      })
    }
  }
}
</script>
